export default {
  path: "/case",
  meta: {
    title: "客户案例",
  },
  component: () => import("@/views/common/moduleMain.vue"),
  children: [
    {
      path: "/cooperation/:menuId",
      meta: {
        title: "校企合作",
        contentType: "c-4",
        sortType: "s-206",
      },
      component: () => import("@/views/case/Cooperation.vue"),
    },
    {
      path: "/achievements/:menuId",
      meta: {
        title: "学生成果",
        contentType: "c-4",
        sortType: "s-207",
      },
      component: () => import("@/views/case/Achievements.vue"),
    },
  ],
};
